module.exports = __webpack_public_path__ + "bg_ios_qr.ae2b85b.png";